import { useEffect, useState } from 'react';

/**
 * Custom hook that tracks whether the given media query matches or not.
 *
 * @param query A media query string, e.g. "(min-width: 768px)".
 * @returns A boolean indicating whether the media query matches or not.
 */
const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setMatches(window.matchMedia(query).matches);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;
